import { inject, Injectable } from '@angular/core';
import { SuccessModalComponent } from '@shared/components/success-modal/success-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private ngbModalService = inject(NgbModal);
  constructor() {}

  showSuccessModal() {
    const audio = new Audio('assets/voice/notification.mp3');
    audio.play();

    const ngbModalRef = this.ngbModalService.open(SuccessModalComponent, {
      centered: true,
      backdrop: false,
    });
    setTimeout(() => {
      ngbModalRef.close();
    }, 2000);
  }
}
